/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramTransactionsUserControllerFindAllQueryResponse,
  TelegramTransactionsUserControllerFindAllQueryParams,
  TelegramTransactionsUserControllerFindAll401,
} from '../types/TelegramTransactionsUserControllerFindAll.ts';

function getTelegramTransactionsUserFindAllUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/transactions` as const };
  return res;
}

/**
 * {@link /api/user/telegram/transactions}
 */
export async function telegramTransactionsUserFindAll(
  params?: TelegramTransactionsUserControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramTransactionsUserControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramTransactionsUserControllerFindAll401>,
    unknown
  >({ method: 'GET', url: getTelegramTransactionsUserFindAllUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
